const API_KEY = import.meta.env.VITE_MAILMODO_API_KEY as string | undefined;
const BASE_URL = "https://api.mailmodo.com/api/v1";

type MailmodoProperties = Record<string, string | number | boolean | null | undefined>;

export async function sendMailmodoEvent(
  email: string,
  eventName: string,
  eventProperties?: MailmodoProperties,
): Promise<void> {
  if (!API_KEY || !email) return;
  await fetch(`${BASE_URL}/addEvent`, {
    method: "POST",
    headers: { "Content-Type": "application/json", mmApiKey: API_KEY },
    body: JSON.stringify({
      email,
      event_name: eventName,
      ts: Math.floor(Date.now() / 1000),
      event_properties: eventProperties,
    }),
  }).catch(() => {});
}